export default {
    totalEmployees: 'พนักงานทั้งหมด',
    mon: 'จ.',
    tues: 'อ.',
    wednes: 'พ.',
    thurs: 'พฤ.',
    fri: 'ศ.',
    satur: 'ส.',
    sun: 'อา.',
    present: 'ตรงเวลา',
    late: 'สาย'
}
